import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { request } from 'utils';
import { FETCH_SEO_META_REQUEST, FETCH_SEO_META_SUCCESS, FETCH_SEO_META_FAILURE, FETCH_SEO_LINKS_BLOCKS_REQUEST, FETCH_SEO_LINKS_BLOCKS_SUCCESS, FETCH_SEO_LINKS_BLOCKS_FAILURE, FETCH_SEO_TEXTS_BLOCKS_REQUEST, FETCH_SEO_TEXTS_BLOCKS_SUCCESS, FETCH_SEO_TEXTS_BLOCKS_FAILURE } from 'actionTypes';
import { makeGetSeoUrl, makeGetSeoMeta, makeGetSeoLinksBlocks, makeGetSeoTextsBlocks } from 'selectors';
var getSeoUrl = makeGetSeoUrl();
var getSeoMeta = makeGetSeoMeta();
var getSeoLinksBlocks = makeGetSeoLinksBlocks();
var getSeoTextsBlocks = makeGetSeoTextsBlocks();

var getShouldFetchSeoMeta = function getShouldFetchSeoMeta(state, props) {
  var _getSeoMeta = getSeoMeta(state, props),
      isFetching = _getSeoMeta.isFetching,
      isLoaded = _getSeoMeta.isLoaded;

  return !(isFetching || isLoaded);
};

export var fetchSeoMeta = function fetchSeoMeta(props) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var state, url, requestURL, _yield$request, _yield$request$data, metaTitle, metaDescription, pageTitle, pageDescription;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = getState();

              if (getShouldFetchSeoMeta(state, props)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", true);

            case 3:
              url = getSeoUrl(state, props);
              dispatch({
                type: FETCH_SEO_META_REQUEST,
                payload: {
                  url: url
                }
              });
              requestURL = "".concat(process.env.APP_SEO_META_API_ROOT, "?url=").concat(url);
              _context.prev = 6;
              _context.next = 9;
              return request(requestURL);

            case 9:
              _yield$request = _context.sent;
              _yield$request$data = _yield$request.data;
              metaTitle = _yield$request$data.title;
              metaDescription = _yield$request$data.description;
              pageTitle = _yield$request$data.h1;
              pageDescription = _yield$request$data.h2;
              return _context.abrupt("return", dispatch({
                type: FETCH_SEO_META_SUCCESS,
                payload: {
                  url: url,
                  metaTitle: metaTitle,
                  metaDescription: metaDescription,
                  pageTitle: pageTitle,
                  pageDescription: pageDescription
                }
              }));

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](6);
              return _context.abrupt("return", dispatch({
                type: FETCH_SEO_META_FAILURE,
                payload: {
                  url: url
                }
              }));

            case 21:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[6, 18]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var getShouldFetchSeoLinksBlocks = function getShouldFetchSeoLinksBlocks(state, props) {
  var _getSeoLinksBlocks = getSeoLinksBlocks(state, props),
      isFetching = _getSeoLinksBlocks.isFetching,
      isLoaded = _getSeoLinksBlocks.isLoaded;

  return !(isFetching || isLoaded);
};

export var fetchSeoLinksBlocks = function fetchSeoLinksBlocks(props) {
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(dispatch, getState) {
      var state, url, requestURL, response;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState();

              if (getShouldFetchSeoLinksBlocks(state, props)) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return", true);

            case 3:
              url = getSeoUrl(state, props);
              dispatch({
                type: FETCH_SEO_LINKS_BLOCKS_REQUEST,
                payload: {
                  url: url
                }
              });
              requestURL = "".concat(process.env.APP_SEO_LINKS_BLOCKS_API_ROOT, "?url=").concat(process.env.APP_ROUTER_BASENAME).concat(props.location.pathname, "&locale=").concat(props.intl.locale);
              _context2.prev = 6;
              _context2.next = 9;
              return request(requestURL);

            case 9:
              response = _context2.sent;
              return _context2.abrupt("return", dispatch({
                type: FETCH_SEO_LINKS_BLOCKS_SUCCESS,
                payload: {
                  url: url,
                  items: response.data
                }
              }));

            case 13:
              _context2.prev = 13;
              _context2.t0 = _context2["catch"](6);
              return _context2.abrupt("return", dispatch({
                type: FETCH_SEO_LINKS_BLOCKS_FAILURE,
                payload: {
                  url: url
                }
              }));

            case 16:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 13]]);
    }));

    return function (_x3, _x4) {
      return _ref2.apply(this, arguments);
    };
  }();
};

var getShouldFetchSeoTexts = function getShouldFetchSeoTexts(state, props) {
  var _getSeoTextsBlocks = getSeoTextsBlocks(state, props),
      isFetching = _getSeoTextsBlocks.isFetching,
      isLoaded = _getSeoTextsBlocks.isLoaded;

  return !(isFetching || isLoaded);
};

var fetchSeoTextsBlocksMenu = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(data, locale) {
    var id, requestUrl, menu;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (data.length) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", []);

          case 2:
            _context3.prev = 2;
            id = data[0].id;
            requestUrl = "".concat(process.env.APP_SEO_TEXTS_BLOCKS_MENU_API_ROOT, "?id=").concat(id, "&locale=").concat(locale);
            _context3.next = 7;
            return request(requestUrl);

          case 7:
            menu = _context3.sent;
            return _context3.abrupt("return", menu);

          case 11:
            _context3.prev = 11;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", []);

          case 14:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 11]]);
  }));

  return function fetchSeoTextsBlocksMenu(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

export var fetchSeoTextsBlocks = function fetchSeoTextsBlocks(props) {
  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(dispatch, getState) {
      var state, url, requestURL, response, menu;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              state = getState();

              if (getShouldFetchSeoTexts(state, props)) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return", true);

            case 3:
              url = getSeoUrl(state, props);
              dispatch({
                type: FETCH_SEO_TEXTS_BLOCKS_REQUEST,
                payload: {
                  url: url
                }
              });
              requestURL = "".concat(process.env.APP_SEO_TEXTS_BLOCKS_API_ROOT, "?url=").concat(encodeURIComponent("".concat(process.env.APP_MINFIN_DOMAIN).concat(process.env.APP_ROUTER_BASENAME).concat(props.location.pathname)), "&locale=").concat(props.intl.locale);
              _context4.prev = 6;
              _context4.next = 9;
              return request(requestURL);

            case 9:
              response = _context4.sent;
              _context4.next = 12;
              return fetchSeoTextsBlocksMenu(response, props.intl.locale);

            case 12:
              menu = _context4.sent;
              return _context4.abrupt("return", dispatch({
                type: FETCH_SEO_TEXTS_BLOCKS_SUCCESS,
                payload: {
                  url: url,
                  items: response,
                  menu: menu
                }
              }));

            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](6);
              return _context4.abrupt("return", dispatch({
                type: FETCH_SEO_TEXTS_BLOCKS_FAILURE,
                payload: {
                  url: url
                }
              }));

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[6, 16]]);
    }));

    return function (_x7, _x8) {
      return _ref4.apply(this, arguments);
    };
  }();
};